import { motion, useScroll, useSpring } from 'framer-motion';

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 28, mass: 0.4 });

  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress"
      className="fixed left-0 top-0 z-[200] h-[3px] w-full origin-left bg-gradient-to-r from-arc via-electric to-gold"
      style={{ scaleX }}
    />
  );
}
